import mixinOptionExtensions from './mixin-package-option'
import mixinEnableWhen from './mixin-enable-when'

import VsFormItemLabel from './form-item-label'

import { camelize, isObject, compact, toArray } from 'vessel/utils'

function validator(data) {
  if (!data)
    throw new Error('item data must be an Object.')
  else if (!data.$id)
    throw new Error('item $id is unvalidated.')
  else if (!data.$type)
    throw new Error('item $type is unvalidated.')
}

export default {
  name: 'VsFormItemBuilder',
  mixins: [
    mixinOptionExtensions,
    mixinEnableWhen
  ],
  props: {
    data: {
      type: Object,
      default: null
    },
    prop: {
      type: String,
      default() {
        return this.data.$id
      }
    },
    itemValue: {},
    value: {
      type: Object,
      default: null
    },
    disabled: {
      type: Boolean,
      default: null
    }
  },
  render(h) {
    if (!this._show) return

    validator(this.data)

    const colSpan = (this.data.$attrs || {}).span
    const classes = this.$vessel.apply({
      gridColumnSpan: colSpan,
      margin: 0
    })

    const itemOptions = {
      props: {
        prop: this.prop,
        label: this.data.label,
        rules: compact(toArray(this.data.rules))
      },
      attrs: { ...this.data.$attrs, span: undefined },
      class: classes
    }

    const { formItem } = this.data.$tag || {}

    if (formItem === false) {
      const { props, attrs, ...formColumnProps } = itemOptions
      const formItemProps = { ...props, ...attrs, margin: 0 }

      return this.renderFormItemContent(h, this.data, this.itemValue, { formItemProps, formColumnProps })
    } else {
      const itemContent = this.renderFormItemContent(h, this.data, this.itemValue)
      const helpText = this.data.$attrs ? this.data.$attrs.help : null
      let helpTag = null

      if (helpText) {
        helpTag = h(VsFormItemLabel, { slot: 'label', props: { label: this.data.label, help: helpText } })
      }

      return h('vs-form-item', itemOptions, [itemContent, helpTag])
    }
  },
  methods: {
    renderFormItemContent(h, data, value, extraProps) {
      let input = isObject(data.$el) ? data.$el : {}

      let types = {
        'checkbox-button': 'checkbox-group',
        'radio-button': 'radio-group',
        [data.$type]: data.$type
      }

      let elType = data.$tag ? data.$tag : `vs-${types[data.$type]}`
      let props  = Object.assign({}, input, { value })

      const onInput = data.on && data.on.input
      const updateValue = data.$updateValue

      this.disabled && (props.disabled = this.disabled)

      const typeOptions = {
        attrs: {
          ...props,
          ...extraProps,
          label: data.label,
          name: data.$id
        },
        props,
        on: {
          ...data.on,
          input: (value) => {
            if (typeof onInput == 'function') {
              onInput.call(this, value)
            }

            if (updateValue) {
              const updateOtherValue = (otherVal) => {
                this.$emit('updateValue', { ...otherVal })
              }

              if (Array.isArray(updateValue)) {
                updateValue.forEach(updateOtherValue)
              } else {
                updateOtherValue(updateValue)
              }
            }

            this.$emit('updateValue', { id: data.$id, value })
          }
        }
      }

      const renderOptions = () => {
        let optRenderer = this[`${camelize(data.$type)}_opt`]

        if (typeof optRenderer === 'function' && Array.isArray(data.$options))
          return data.$options.map(optRenderer)
      }

      return h(elType, typeOptions, [renderOptions()])
    }
  }
}
